<template>
  <div
    :class=" size === 'sm' ? 'max-w-[490px]' : 'max-w-[650px]' "
    class="flex flex-col items-center justify-center w-full h-full text-center  px-2 sm:px-8 text-primary"
  >
    <div class="max-w-[230px] h-[136px] overflow-hidden w-full flex justify-center">
      <component :is="imageComponent" />
    </div>

    <div class="text-xl font-bold mt-4 md:mt-8">
      {{ heading }}
    </div>
    <div class="mt-2 mb-8 text-sm text-secondary">
      {{ description }}
    </div>

    <!-- Slot for additional content like buttons -->
    <div v-if="$slots.actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import EmptyList from './EmptyList.vue'
import EmptyDataCaptures from './EmptyDataCaptures.vue'
import EmptyEvents from './EmptyEvents.vue'
import EmptyTickets from './EmptyTickets.vue'
import EmptyMessages from './EmptyMessages.vue'

const props = defineProps({
  /**
   * The image component to display
   */
  image: {
    type: String,
    default: 'EmptyList',
  },

  /**
   * The heading text to display
   */
  heading: {
    type: String,
    required: false,
  },

  /**
   * The description text to display
   */
  description: {
    type: String,
    required: true,
  },

  size: {
    type: String,
    required: false,
    default: 'sm',
  },

})

const imageComponent = computed(() => {
  switch (props.image) {
    case 'EmptyDataCaptures':
      return EmptyDataCaptures
    case 'EmptyList':
    case 'EmptyEvents':
      return EmptyEvents
    case 'EmptyMessages':
      return EmptyMessages
    case 'EmptyTickets':
      return EmptyTickets
    default:
      return EmptyList
  }
})
</script>
